import { formatMoney } from '@/lib/dataFormat';
import { cn } from './cn';

/** Сумма в минимальных единицах валюты: копейках/центах, без потери точности ввода. */
export function Money({
  minorUnits,
  currency,
  total = false,
}: {
  minorUnits: number;
  currency: string;
  total?: boolean;
}) {
  return (
    <span
      data-slot="money"
      title={currency}
      className={cn('whitespace-nowrap tabular-nums', total && 'font-semibold')}
    >
      {formatMoney(minorUnits, currency)}
    </span>
  );
}
